import * as settingType from "../../types/admin/settingType";

export const idleSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_IDLE_REQUEST:
      return {
        ...state,
        idleLoading: true,
      };
    case settingType.ADD_IDLE_SUCCESS:
      return {
        ...state,
        idleLoading: false,
        idleInfo: payload,
        idleError: "",
      };
    case settingType.ADD_IDLE_FAIL:
      return {
        ...state,
        idleLoading: false,
        idleError: payload,
        idleInfo: [],
      };
    default:
      return state;
  }
};

export const idleTimeSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_IDLE_TIME_LIMIT_REQUEST:
      return {
        ...state,
        idleTimeLoading: true,
      };
    case settingType.ADD_IDLE_TIME_LIMIT_SUCCESS:
      return {
        ...state,
        idleTimeLoading: false,
        idleTimeInfo: payload,
        idleTimeError: "",
      };
    case settingType.ADD_IDLE_TIME_LIMIT_FAIL:
      return {
        ...state,
        idleTimeLoading: false,
        idleTimeError: payload,
        idleTimeInfo: [],
      };
    default:
      return state;
  }
};

export const screenshotLimitSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_SCREENSHOT_LIMIT_REQUEST:
      return {
        ...state,
        screenshotLimitLoading: true,
      };
    case settingType.ADD_SCREENSHOT_LIMIT_SUCCESS:
      return {
        ...state,
        screenshotLimitLoading: false,
        screenshotLimitInfo: payload,
        screenshotLimitError: "",
      };
    case settingType.ADD_SCREENSHOT_LIMIT_FAIL:
      return {
        ...state,
        screenshotLimitLoading: false,
        screenshotLimitError: payload,
        screenshotLimitInfo: [],
      };
    default:
      return state;
  }
};

export const weeklyLimitSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_WEEKLY_LIMIT_REQUEST:
      return {
        ...state,
        weeklyLimitLoading: true,
      };
    case settingType.ADD_WEEKLY_LIMIT_SUCCESS:
      return {
        ...state,
        weeklyLimitLoading: false,
        weeklyLimitInfo: payload,
        weeklyLimitError: "",
      };
    case settingType.ADD_WEEKLY_LIMIT_FAIL:
      return {
        ...state,
        weeklyLimitLoading: false,
        weeklyLimitError: payload,
        weeklyLimitInfo: [],
      };
    default:
      return state;
  }
};

export const notificationSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_NOTIFICATION_REQUEST:
      return {
        ...state,
        notifyLoading: true,
      };
    case settingType.ADD_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifyLoading: false,
        notifyInfo: payload,
        notifyError: "",
      };
    case settingType.ADD_NOTIFICATION_FAIL:
      return {
        ...state,
        notifyLoading: false,
        notifyError: payload,
        notifyInfo: [],
      };
    default:
      return state;
  }
};

export const getCompanySettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.GET_DATA_Of_USER_SETTING_BY_COMPANY_REQUEST:
      return {
        ...state,
        getCompSettingLoading: true,
      };
    case settingType.GET_DATA_Of_USER_SETTING_BY_COMPANY_SUCCESS:
      return {
        ...state,
        getCompSettingLoading: false,
        getCompSettingInfo: payload,
        getCompSettingError: "",
      };
    case settingType.GET_DATA_Of_USER_SETTING_BY_COMPANY_FAIL:
      return {
        ...state,
        getCompSettingLoading: false,
        getCompSettingError: payload,
        getCompSettingInfo: [],
      };
    default:
      return state;
  }
};

export const timeHeroSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_TIMEHERO_REQUEST:
      return {
        ...state,
        timeHeroSettingLoading: true,
      };
    case settingType.ADD_TIMEHERO_SUCCESS:
      return {
        ...state,
        timeHeroSettingLoading: false,
        timeHeroSettingInfo: payload,
        timeHeroSettingError: "",
      };
    case settingType.ADD_TIMEHERO_FAIL:
      return {
        ...state,
        timeHeroSettingLoading: false,
        timeHeroSettingError: payload,
        timeHeroSettingInfo: [],
      };
    default:
      return state;
  }
};

export const AddCompanySettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMPANY_SETTING_REQUEST:
      return {
        ...state,
        CompanySettingLoading: true,
      };
    case settingType.ADD_COMPANY_SETTING_SUCCESS:
      return {
        ...state,
        CompanySettingLoading: false,
        CompanySettingInfo: payload,
        CompanySettingError: "",
      };
    case settingType.ADD_COMPANY_SETTING_FAIL:
      return {
        ...state,
        CompanySettingLoading: false,
        CompanySettingError: payload,
        CompanySettingInfo: [],
      };
    default:
      return state;
  }
};

export const AddIdleTimeCompanySettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_ALL_COMPANY_USERS_IDLE_TIME_REQUEST:
      return {
        ...state,
        CompIdleTSetLoading: true,
      };
    case settingType.ADD_ALL_COMPANY_USERS_IDLE_TIME_SUCCESS:
      return {
        ...state,
        CompIdleTSetLoading: false,
        CompIdleTSetInfo: payload,
        CompIdleTSetError: "",
      };
    case settingType.ADD_ALL_COMPANY_USERS_IDLE_TIME_FAIL:
      return {
        ...state,
        CompIdleTSetLoading: false,
        CompIdleTSetError: payload,
        CompIdleTSetInfo: [],
      };
    default:
      return state;
  }
};

export const AddScreenshotCompanySettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_ALL_COMPANY_USERS_SCREENSHOT_REQUEST:
      return {
        ...state,
        CompScreenSetLoading: true,
      };
    case settingType.ADD_ALL_COMPANY_USERS_SCREENSHOT_SUCCESS:
      return {
        ...state,
        CompScreenSetLoading: false,
        CompScreenSetInfo: payload,
        CompScreenSetError: "",
      };
    case settingType.ADD_ALL_COMPANY_USERS_SCREENSHOT_FAIL:
      return {
        ...state,
        CompScreenSetLoading: false,
        CompScreenSetError: payload,
        CompScreenSetInfo: [],
      };
    default:
      return state;
  }
};

export const AddTimeHeroCompanySettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_ALL_COMPANY_USERS_TIME_HERO_REQUEST:
      return {
        ...state,
        CompTHSetLoading: true,
      };
    case settingType.ADD_ALL_COMPANY_USERS_TIME_HERO_SUCCESS:
      return {
        ...state,
        CompTHSetLoading: false,
        CompTHSetInfo: payload,
        CompTHSetError: "",
      };
    case settingType.ADD_ALL_COMPANY_USERS_TIME_HERO_FAIL:
      return {
        ...state,
        CompTHSetLoading: false,
        CompTHSetError: payload,
        CompTHSetInfo: [],
      };
    default:
      return state;
  }
};

export const AddWeeklyLimitCompanySettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_REQUEST:
      return {
        ...state,
        CompWLSetLoading: true,
      };
    case settingType.ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_SUCCESS:
      return {
        ...state,
        CompWLSetLoading: false,
        CompWLSetInfo: payload,
        CompWLSetError: "",
      };
    case settingType.ADD_ALL_COMPANY_USERS_WEEKLY_LIMIT_FAIL:
      return {
        ...state,
        CompWLSetLoading: false,
        CompWLSetError: payload,
        CompWLSetInfo: [],
      };
    default:
      return state;
  }
};

export const getAllCompanySettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.GET_COMPANY_SETTING_REQUEST:
      return {
        ...state,
        getCompLoading: true,
      };
    case settingType.GET_COMPANY_SETTING_SUCCESS:
      return {
        ...state,
        getCompLoading: false,
        getCompInfo: payload,
        getCompError: "",
      };
    case settingType.GET_COMPANY_SETTING_FAIL:
      return {
        ...state,
        getCompLoading: false,
        getCompError: payload,
        getCompInfo: [],
      };
    default:
      return state;
  }
};

export const companyUserTypeSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMPANY_TYPE_REQUEST:
      return {
        ...state,
        userTypeLoading: true,
      };
    case settingType.ADD_COMPANY_TYPE_SUCCESS:
      return {
        ...state,
        userTypeLoading: false,
        userTypeInfo: payload,
        userTypeError: "",
      };
    case settingType.ADD_COMPANY_TYPE_FAIL:
      return {
        ...state,
        userTypeLoading: false,
        userTypeError: payload,
        userTypeInfo: [],
      };
    default:
      return state;
  }
};

export const companyUserAppTrackSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_ALL_COMPANY_USERS_APP_TRACK_REQUEST:
      return {
        ...state,
        userCompAppLoading: true,
      };
    case settingType.ADD_ALL_COMPANY_USERS_APP_TRACK_SUCCESS:
      return {
        ...state,
        userCompAppLoading: false,
        userCompAppInfo: payload,
        userCompAppError: "",
      };
    case settingType.ADD_ALL_COMPANY_USERS_APP_TRACK_FAIL:
      return {
        ...state,
        userCompAppLoading: false,
        userCompAppError: payload,
        userCompAppInfo: [],
      };
    default:
      return state;
  }
};

export const userAppTrackSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_APP_TRACK_REQUEST:
      return {
        ...state,
        userAppLoading: true,
      };
    case settingType.ADD_APP_TRACK_SUCCESS:
      return {
        ...state,
        userAppLoading: false,
        userAppInfo: payload,
        userAppError: "",
      };
    case settingType.ADD_APP_TRACK_FAIL:
      return {
        ...state,
        userAppLoading: false,
        userAppError: payload,
        userAppInfo: [],
      };
    default:
      return state;
  }
};

export const userPayRateSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_PAY_RATE_REQUEST:
      return {
        ...state,
        userPayLoading: true,
      };
    case settingType.ADD_PAY_RATE_SUCCESS:
      return {
        ...state,
        userPayLoading: false,
        userPayInfo: payload,
        userPayError: "",
      };
    case settingType.ADD_PAY_RATE_FAIL:
      return {
        ...state,
        userPayLoading: false,
        userPayError: payload,
        userPayInfo: [],
      };
    default:
      return state;
  }
};

export const userWorkingSettingReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_WORKING_COMPANY_SETTING_REQUEST:
      return {
        ...state,
        companyWorkingLoading: true,
      };
    case settingType.ADD_WORKING_COMPANY_SETTING_SUCCESS:
      return {
        ...state,
        companyWorkingLoading: false,
        companyWorkingInfo: payload,
        companyWorkingError: "",
      };
    case settingType.ADD_WORKING_COMPANY_SETTING_FAIL:
      return {
        ...state,
        companyWorkingLoading: false,
        companyWorkingError: payload,
        companyWorkingInfo: [],
      };
    default:
      return state;
  }
};

export const addCompanyWorkingPolicyReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMPANY_WORKING_POLICY_REQUEST:
      return {
        ...state,
        companyWorkingPolicyLoading: true,
      };
    case settingType.ADD_COMPANY_WORKING_POLICY_SUCCESS:
      return {
        ...state,
        companyWorkingPolicyLoading: false,
        companyWorkingPolicyInfo: payload,
        companyWorkingPolicyError: "",
      };
    case settingType.ADD_COMPANY_WORKING_POLICY_FAIL:
      return {
        ...state,
        companyWorkingPolicyLoading: false,
        companyWorkingPolicyError: payload,
        companyWorkingPolicyInfo: [],
      };
    default:
      return state;
  }
};

export const addApproveLeaveSettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_APPROVE_LEAVE_SETIING_REQUEST:
      return {
        ...state,
        companyApproveLeaveSettLoading: true,
      };
    case settingType.ADD_APPROVE_LEAVE_SETIING_SUCCESS:
      return {
        ...state,
        companyApproveLeaveSettLoading: false,
        companyApproveLeaveSettInfo: payload,
        companyApproveLeaveSettError: "",
      };
    case settingType.ADD_APPROVE_LEAVE_SETIING_FAIL:
      return {
        ...state,
        companyApproveLeaveSettLoading: false,
        companyApproveLeaveSettError: payload,
        companyApproveLeaveSettInfo: [],
      };
    default:
      return state;
  }
};

export const addExcludeLeaveSettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_EXCLUDE_LEAVE_SETIING_REQUEST:
      return {
        ...state,
        companyExcludeLeaveSettLoading: true,
      };
    case settingType.ADD_EXCLUDE_LEAVE_SETIING_SUCCESS:
      return {
        ...state,
        companyExcludeLeaveSettLoading: false,
        companyExcludeLeaveSettInfo: payload,
        companyExcludeLeaveSettError: "",
      };
    case settingType.ADD_EXCLUDE_LEAVE_SETIING_FAIL:
      return {
        ...state,
        companyExcludeLeaveSettLoading: false,
        companyExcludeLeaveSettError: payload,
        companyExcludeLeaveSettInfo: [],
      };
    default:
      return state;
  }
};
//
export const addCompanyPayrollCompSettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMPANY_PAYROLL_COMP_SETTING_REQUEST:
      return {
        ...state,
        addPayrollCompSettLoading: true,
      };
    case settingType.ADD_COMPANY_PAYROLL_COMP_SETTING_SUCCESS:
      return {
        ...state,
        addPayrollCompSettLoading: false,
        addPayrollCompSettInfo: payload,
        addPayrollCompSettError: "",
      };
    case settingType.ADD_COMPANY_PAYROLL_COMP_SETTING_FAIL:
      return {
        ...state,
        addPayrollCompSettLoading: false,
        addPayrollCompSettError: payload,
        addPayrollCompSettInfo: [],
      };
    default:
      return state;
  }
};

export const getCompanyPayrollCompSettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.GET_COMPANY_PAYROLL_COMP_SETTING_REQUEST:
      return {
        ...state,
        getPayrollCompSettLoading: true,
      };
    case settingType.GET_COMPANY_PAYROLL_COMP_SETTING_SUCCESS:
      return {
        ...state,
        getPayrollCompSettLoading: false,
        getPayrollCompSettInfo: payload,
        getPayrollCompSettError: "",
      };
    case settingType.GET_COMPANY_PAYROLL_COMP_SETTING_FAIL:
      return {
        ...state,
        getPayrollCompSettLoading: false,
        getPayrollCompSettError: payload,
        getPayrollCompSettInfo: [],
      };
    default:
      return state;
  }
};

export const archivedCompanyPayrollCompSettingsReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_REQUEST:
      return {
        ...state,
        archivePayrollCompSettLoading: true,
      };
    case settingType.ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_SUCCESS:
      return {
        ...state,
        archivePayrollCompSettLoading: false,
        archivePayrollCompSettInfo: payload,
        archivePayrollCompSettError: "",
      };
    case settingType.ARCHIVED_COMPANY_PAYROLL_COMP_SETTING_FAIL:
      return {
        ...state,
        archivePayrollCompSettLoading: false,
        archivePayrollCompSettError: payload,
        archivePayrollCompSettInfo: [],
      };
    default:
      return state;
  }
};

export const addCompanyPayrollBasicSettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMPANY_BASIC_PAYROLL_SETTING_REQUEST:
      return {
        ...state,
        addPayrollBasicSettLoading: true,
      };
    case settingType.ADD_COMPANY_BASIC_PAYROLL_SETTING_SUCCESS:
      return {
        ...state,
        addPayrollBasicSettLoading: false,
        addPayrollBasicSettInfo: payload,
        addPayrollBasicSettError: "",
      };
    case settingType.ADD_COMPANY_BASIC_PAYROLL_SETTING_FAIL:
      return {
        ...state,
        addPayrollBasicSettLoading: false,
        addPayrollBasicSettError: payload,
        addPayrollBasicSettInfo: [],
      };
    default:
      return state;
  }
};

export const addDocumentCompanySettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMPANY_DOCUMENT_SETTING_REQUEST:
      return {
        ...state,
        addDocCompSettLoading: true,
      };
    case settingType.ADD_COMPANY_DOCUMENT_SETTING_SUCCESS:
      return {
        ...state,
        addDocCompSettLoading: false,
        addDocCompSettInfo: payload,
        addDocCompSettError: "",
      };
    case settingType.ADD_COMPANY_DOCUMENT_SETTING_FAIL:
      return {
        ...state,
        addDocCompSettLoading: false,
        addDocCompSettError: payload,
        addDocCompSettInfo: [],
      };
    default:
      return state;
  }
};
export const archivedCompanySalaryCompSettingsReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ARCHIVED_COMPANY_SALARY_COMP_SETTING_REQUEST:
      return {
        ...state,
        archiveSalaryCompSettLoading: true,
      };
    case settingType.ARCHIVED_COMPANY_SALARY_COMP_SETTING_SUCCESS:
      return {
        ...state,
        archiveSalaryCompSettLoading: false,
        archiveSalaryCompSettInfo: payload,
        archiveSalaryCompSettError: "",
      };
    case settingType.ARCHIVED_COMPANY_SALARY_COMP_SETTING_FAIL:
      return {
        ...state,
        archiveSalaryCompSettLoading: false,
        archiveSalaryCompSettError: payload,
        archiveSalaryCompSettInfo: [],
      };
    default:
      return state;
  }
};

export const addCompanySalarySettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMPANY_SALARY_SETTING_REQUEST:
      return {
        ...state,
        addPayrollSalarySettLoading: true,
      };
    case settingType.ADD_COMPANY_SALARY_SETTING_SUCCESS:
      return {
        ...state,
        addPayrollSalarySettLoading: false,
        addPayrollSalarySettInfo: payload,
        addPayrollSalarySettError: "",
      };
    case settingType.ADD_COMPANY_SALARY_SETTING_FAIL:
      return {
        ...state,
        addPayrollSalarySettLoading: false,
        addPayrollSalarySettError: payload,
        addPayrollSalarySettInfo: [],
      };
    default:
      return state;
  }
};

export const addCompSalarySettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMP_SALARY_SETTING_REQUEST:
      return {
        ...state,
        addSalarySettLoading: true,
      };
    case settingType.ADD_COMP_SALARY_SETTING_SUCCESS:
      return {
        ...state,
        addSalarySettLoading: false,
        addSalarySettInfo: payload,
        addSalarySettError: "",
      };
    case settingType.ADD_COMP_SALARY_SETTING_FAIL:
      return {
        ...state,
        addSalarySettLoading: false,
        addSalarySettError: payload,
        addSalarySettInfo: [],
      };
    default:
      return state;
  }
};

export const deleteCompSalarySettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.DELETE_COMP_SALARY_SETTING_REQUEST:
      return {
        ...state,
        deleteSalarySettLoading: true,
      };
    case settingType.DELETE_COMP_SALARY_SETTING_SUCCESS:
      return {
        ...state,
        deleteSalarySettLoading: false,
        deleteSalarySettInfo: payload,
        deleteSalarySettError: "",
      };
    case settingType.DELETE_COMP_SALARY_SETTING_FAIL:
      return {
        ...state,
        deleteSalarySettLoading: false,
        deleteSalarySettError: payload,
        deleteSalarySettInfo: [],
      };
    default:
      return state;
  }
};

export const archivedCompanyTaxSettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ARCHIVED_COMPANY_TAX_SETTING_REQUEST:
      return {
        ...state,
        archiveTaxCompSettLoading: true,
      };
    case settingType.ARCHIVED_COMPANY_TAX_SETTING_SUCCESS:
      return {
        ...state,
        archiveTaxCompSettLoading: false,
        archiveTaxCompSettInfo: payload,
        archiveTaxCompSettError: "",
      };
    case settingType.ARCHIVED_COMPANY_TAX_SETTING_FAIL:
      return {
        ...state,
        archiveTaxCompSettLoading: false,
        archiveTaxCompSettError: payload,
        archiveTaxCompSettInfo: [],
      };
    default:
      return state;
  }
};

export const addActiveCompanyTaxSettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_ACTIVE_COMPANY_TAX_SETTING_REQUEST:
      return {
        ...state,
        addPayrollTaxSettLoading: true,
      };
    case settingType.ADD_ACTIVE_COMPANY_TAX_SETTING_SUCCESS:
      return {
        ...state,
        addPayrollTaxSettLoading: false,
        addPayrollTaxSettInfo: payload,
        addPayrollTaxSettError: "",
      };
    case settingType.ADD_ACTIVE_COMPANY_TAX_SETTING_FAIL:
      return {
        ...state,
        addPayrollTaxSettLoading: false,
        addPayrollTaxSettError: payload,
        addPayrollTaxSettInfo: [],
      };
    default:
      return state;
  }
};

export const addCompanyTaxSettingsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_COMPANY_TAX_SETTING_REQUEST:
      return {
        ...state,
        addPayrollTaxSettLoading: true,
      };
    case settingType.ADD_COMPANY_TAX_SETTING_SUCCESS:
      return {
        ...state,
        addPayrollTaxSettLoading: false,
        addPayrollTaxSettInfo: payload,
        addPayrollTaxSettError: "",
      };
    case settingType.ADD_COMPANY_TAX_SETTING_FAIL:
      return {
        ...state,
        addPayrollTaxSettLoading: false,
        addPayrollTaxSettError: payload,
        addPayrollTaxSettInfo: [],
      };
    default:
      return state;
  }
};

export const addCompanyLeaveApproverSettReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_LEAVE_APPROVER_SETIING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.ADD_LEAVE_APPROVER_SETIING_SUCCESS:
      return {
        ...state,
        loading: false,
        addCompanyLeaveApproverSettInfo: payload,
        error: "",
      };
    case settingType.ADD_LEAVE_APPROVER_SETIING_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        addCompanyLeaveApproverSettInfo: [],
      };
    default:
      return state;
  }
};

export const addCompanyExpenseApproverSettReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_EXPENSE_APPROVER_SETIING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.ADD_EXPENSE_APPROVER_SETIING_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.ADD_EXPENSE_APPROVER_SETIING_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const addCompanyLeaveReasonSettReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_REASON_LEAVE_SETIING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.ADD_REASON_LEAVE_SETIING_SUCCESS:
      return {
        ...state,
        loading: false,
        addCompanyLeaveReasonSettInfo: payload,
        error: "",
      };
    case settingType.ADD_REASON_LEAVE_SETIING_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        addCompanyLeaveReasonSettInfo: [],
      };
    default:
      return state;
  }
};

export const addCompanyLeaveCalenderSettReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ADD_LEAVE_CALENDER_SETIING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.ADD_LEAVE_CALENDER_SETIING_SUCCESS:
      return {
        ...state,
        loading: false,
        addCompanyLeaveCalenderSettInfo: payload,
        error: "",
      };
    case settingType.ADD_LEAVE_CALENDER_SETIING_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        addCompanyLeaveCalenderSettInfo: [],
      };
    default:
      return state;
  }
};

export const getAllBulkImportsReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.GET_ALL_BULK_IMPORTS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.GET_ALL_BULK_IMPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        allBulkImportInfo: payload,
        error: "",
      };
    case settingType.GET_ALL_BULK_IMPORTS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        allBulkImportInfo: [],
      };
    default:
      return state;
  }
};

export const getAllCustomFieldTemplateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.GET_ALL_CUSTOM_FIELD_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.GET_ALL_CUSTOM_FIELD_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        customFieldsInfo: payload,
        error: "",
      };
    case settingType.GET_ALL_CUSTOM_FIELD_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        customFieldsInfo: [],
      };
    default:
      return state;
  }
};

export const getAllCompanyAttendanceStatusesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.GET_ALL_COMPANY_STATUSES_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.GET_ALL_COMPANY_STATUSES_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.GET_ALL_COMPANY_STATUSES_ATTENDANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const getAllUserAttendanceStatusesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.GET_ALL_USER_STATUSES_ATTENDANCE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.GET_ALL_USER_STATUSES_ATTENDANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.GET_ALL_USER_STATUSES_ATTENDANCE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const createCompanyAttendanceStatusesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.CREATE_COMPANY_ATTENDANCE_STATUSES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.CREATE_COMPANY_ATTENDANCE_STATUSES_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.CREATE_COMPANY_ATTENDANCE_STATUSES_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};

export const updateCompanyAttendanceStatusesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.UPDATE_COMPANY_ATTENDANCE_STATUSES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.UPDATE_COMPANY_ATTENDANCE_STATUSES_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.UPDATE_COMPANY_ATTENDANCE_STATUSES_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const archiveCompanyAttendanceStatusesReducers = (
  state = {},
  action
) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ARCHIVE_COMPANY_ATTENDANCE_STATUSES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.ARCHIVE_COMPANY_ATTENDANCE_STATUSES_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.ARCHIVE_COMPANY_ATTENDANCE_STATUSES_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const archiveUserAttendanceStatusesReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.ARCHIVE_USER_ATTENDANCE_STATUSES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.ARCHIVE_USER_ATTENDANCE_STATUSES_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.ARCHIVE_USER_ATTENDANCE_STATUSES_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        info: [],
      };
    default:
      return state;
  }
};
export const createCustomFieldTemplateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.CREATE_CUSTOM_FIELD_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.CREATE_CUSTOM_FIELD_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        customFieldsInfo: payload,
        error: "",
      };
    case settingType.CREATE_CUSTOM_FIELD_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        customFieldsInfo: [],
      };
    default:
      return state;
  }
};

export const updateOneCustomFieldReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.UPDATE_ONE_CUSTOM_FIELD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.UPDATE_ONE_CUSTOM_FIELD_SUCCESS:
      return {
        ...state,
        loading: false,
        customFieldsInfo: payload,
        error: "",
      };
    case settingType.UPDATE_ONE_CUSTOM_FIELD_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        customFieldsInfo: [],
      };
    default:
      return state;
  }
};

export const deleteCustomFieldTemplateReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.DELETE_CUSTOM_FIELD_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.DELETE_CUSTOM_FIELD_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        customFieldsInfo: payload,
        error: "",
      };
    case settingType.DELETE_CUSTOM_FIELD_TEMPLATE_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        customFieldsInfo: [],
      };
    default:
      return state;
  }
};

export const contactSupportReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.CONTACT_SUPPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.CONTACT_SUPPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.CONTACT_SUPPORT_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        customFieldsInfo: [],
      };
    default:
      return state;
  }
};
export const contactSupportEmailReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case settingType.CONTACT_SUPPORT_EMAIL_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case settingType.CONTACT_SUPPORT_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        info: payload,
        error: "",
      };
    case settingType.CONTACT_SUPPORT_EMAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        customFieldsInfo: [],
      };
    default:
      return state;
  }
};
